import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Options, ChangeContext } from "@angular-slider/ngx-slider";

export interface acLayerParamsInteraface {
  location?: string;
  crop?: string;
  year?: number;
}

@Injectable({
  providedIn: "root",
})
export class AppService {
  dateRange: Array<string> = [];

  updateLayerParams: Subject<acLayerParamsInteraface> = new Subject();

  currentDateIndexLower: number = 3;
  currentDateIndexUpper: number = 8;
  previouscurrentDateIndexUpper: number = 8;
  timelineOptions: Options = {
    floor: 0,
    ceil: 10,
    vertical: true,
    draggableRange: true,
    showTicks: true,
  };

  constructor() {}
}
